// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alegreya:wght@600&family=Amatic+SC&family=BhuTuka+Expanded+One&family=BioRhyme+Expanded&family=Grenze+Gotisch:wght@600&family=Peralta&family=Playfair+Display:wght@500&family=Satisfy&family=Ubuntu:wght@500&display=swap);"]);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
